import React, { useEffect } from "react";

const OakTreeLoader = ({ onComplete }) => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js";
        script.onload = () => {
            const { gsap } = window;

            const trunk = document.getElementById("treeTrunk");
            const branches = document.querySelectorAll(".branch");
            const leaves = document.querySelectorAll(".leaf");
            const finalLogo = document.getElementById("finalLogo");

            gsap.set([branches, leaves, finalLogo], { opacity: 0 });
            gsap.set(trunk, { scaleY: 0, transformOrigin: "bottom center" });

            const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

            // 🌱 1. Grow trunk
            tl.to(trunk, { scaleY: 1, duration: 1.2 });

            // 🌿 2. Grow branches sequentially
            branches.forEach((b, i) => {
                const length = b.getTotalLength();
                b.style.strokeDasharray = length;
                b.style.strokeDashoffset = length;
                tl.to(
                    b,
                    { strokeDashoffset: 0, opacity: 1, duration: 0.7 },
                    "-=0.5" + i * 0.1
                );
            });

            // 🍃 3. Leaves sprout
            tl.to(
                leaves,
                {
                    opacity: 1,
                    scale: 1.3,
                    stagger: 0.2,
                    duration: 0.4,
                    ease: "back.out(2)",
                },
                "-=0.5"
            );

            // 👑 4. Fade branches/leaves out, fade final logo in
            tl.to([trunk, ...branches, ...leaves], { opacity: 0, duration: 0.6 }, "+=0.3");
            tl.to(finalLogo, { opacity: 1, duration: 1 }, "-=0.2");

            tl.call(() => {
                if (onComplete) onComplete();
            });
        };
        document.head.appendChild(script);

        return () => {
            if (script.parentNode) script.parentNode.removeChild(script);
        };
    }, [onComplete]);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#000",
                zIndex: 9999,
            }}
        >
            <svg
                viewBox="0 0 200 200"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "220px", height: "auto", filter: "drop-shadow(0 0 10px gold)" }}
            >
                {/* 🌳 Trunk */}
                <rect id="treeTrunk" x="97" y="120" width="6" height="60" fill="gold" rx="2" />

                {/* 🌿 Branches */}
                <path className="branch" d="M100 120 C90 110, 70 90, 60 70" stroke="gold" strokeWidth="4" fill="none" strokeLinecap="round" />
                <path className="branch" d="M100 120 C110 110, 130 90, 140 70" stroke="gold" strokeWidth="4" fill="none" strokeLinecap="round" />
                <path className="branch" d="M100 100 C85 90, 80 70, 75 50" stroke="gold" strokeWidth="3" fill="none" strokeLinecap="round" />
                <path className="branch" d="M100 100 C115 90, 120 70, 125 50" stroke="gold" strokeWidth="3" fill="none" strokeLinecap="round" />

                {/* 🍃 Leaves */}
                <circle className="leaf" cx="60" cy="70" r="3" fill="gold" />
                <circle className="leaf" cx="75" cy="50" r="3" fill="gold" />
                <circle className="leaf" cx="125" cy="50" r="3" fill="gold" />
                <circle className="leaf" cx="140" cy="70" r="3" fill="gold" />
                <circle className="leaf" cx="100" cy="60" r="3" fill="gold" />

                {/* 👑 Final OakHR Tree + Circle Logo */}
                <g id="finalLogo" transform="scale(0.18) translate(280,260)">
                    <image
                        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABAAAAAQACAYAAAB/HSuDAAEAAElEQVR4nOz9ebwl13Xfh37X3lV1zrnz7XnuBtAAiAYlikKswbJIRnHkMYktErSjwc9xpMgviScl/sj5RBJFyk92EsVJ/KzIkaM4iWTJEqj4kzjPgzwRoh1btiBZAxsg0eh5Hu587xmq9l7vj72rzmkApESKA4b1xae77z1DjecUaq31W78FhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmE"
                        height="1024"
                        style={{ imageRendering: "crisp-edges" }}
                    />
                </g>
            </svg>
        </div>
    );
};

export default OakTreeLoader;
